import { type ModuleEnabledMap } from "~/helpers/moduleFeatureFlags";
import useModuleEnabledState from "~/hooks/useModuleEnabledState";

const useModuleEnabledMap = (): ModuleEnabledMap => useModuleEnabledState().enabledByKey;

export default useModuleEnabledMap;
